'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tile = require('../../../../atoms/tile');

var _tile2 = _interopRequireDefault(_tile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  config: {
    id: 'drawer-tile',
    theme: 'theme-background-color-green',
    columns: 3,
    selectedItemTheme: 'theme-background-color-blue-alt'
  },
  content: {
    headline: {
      text: '50 characters or less'
    },
    paragraph: {
      text: '150 characters or less'
    },
    tiles: [_tile2.default.defaultProps.content, _tile2.default.defaultProps.content, _tile2.default.defaultProps.content, _tile2.default.defaultProps.content, _tile2.default.defaultProps.content, _tile2.default.defaultProps.content],
    footer: {
      text: '150 characters or less'
    }
  },
  className: 'theme-new-money',
  callback: function callback() {}
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/interactive-tiles/drawer/props/default.js
// module id = 1109
// module chunks = 4